import { createClient } from '@supabase/supabase-js'

// Replace these with your actual Supabase credentials
const supabaseUrl = 'https://jutzwrmlgzhujxhhmbqp.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp1dHp3cm1sZ3podWp4aGhtYnFwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc3NzQzOTIsImV4cCI6MjA3MzM1MDM5Mn0.dHerRSZMX0j1cdvvDqsN-Px9EscHetFhSYzrQOhsT9w'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)